import { EditorToolInstructionTypes } from '../../../types/instructions';

import Paragraph from './Paragraph';
import ImageInstruction from './image-instruction/ImageInstruction';
import ImageInstructionBlock from './image-instruction/ImageInstructionBlock';
import TextInstruction from './text-instruction/TextInstruction';
import TextInstructionBlock from './text-instruction/TextInstructionBlock';
import NoteInstruction from './note-instruction/NoteInstruction';
import NoteInstructionBlock from './note-instruction/NoteInstructionBlock';
import VideoInstruction from './video-instruction/VideoInstruction';
import VideoInstructionBlock from './video-instruction/VideoInstructionBlock';
import TitleInstruction from './title-instruction/TitleInstruction';
import TitleInstructionBlock from './title-instruction/TitleInstructionBlock';
import NameScriptInstruction from './name-script-instruction/NameScriptInstruction';
import NameScriptInstructionBlock from './name-script-instruction/NameScriptInstructionBlock';
import DocumentInstruction from './document-page-instruction/DocumentInstruction';
import DocumentInstructionBlock from './document-page-instruction/DocumentInstructionBlock';
import AudioInstruction from './audio-instruction/AudioInstruction';
import AudioInstructionBlock from './audio-instruction/AudioInstructionBlock';
// import WebPageInstruction from './webpage-instruction/WebPageInstruction';
// import WebPageInstructionBlock from './webpage-instruction/WebPageInstructionBlock';

/* eslint-disable @typescript-eslint/no-explicit-any */

const developmentMode = process.env.REACT_APP_BUILD_ENV === 'development';

const DevelopmentTools = {

};

const EDITOR_TOOLS = {
  paragraph: {
    class: Paragraph as any,
    inlineToolbar: true,
  },
  header: {
    class: Paragraph as any,
    inlineToolbar: true,
  },
  /**
   * INSTRUCTIONS
   */
  [EditorToolInstructionTypes.video]: VideoInstruction as any,
  [EditorToolInstructionTypes.videoBlock]: VideoInstructionBlock as any,
  [EditorToolInstructionTypes.audio]: AudioInstruction as any,
  [EditorToolInstructionTypes.audioBlock]: AudioInstructionBlock as any,
  [EditorToolInstructionTypes.image]: ImageInstruction as any,
  [EditorToolInstructionTypes.imageBlock]: ImageInstructionBlock as any,
  [EditorToolInstructionTypes.text]: TextInstruction as any,
  [EditorToolInstructionTypes.textBlock]: TextInstructionBlock as any,
  [EditorToolInstructionTypes.title]: TitleInstruction as any,
  [EditorToolInstructionTypes.titleBlock]: TitleInstructionBlock as any,
  [EditorToolInstructionTypes.note]: NoteInstruction as any,
  [EditorToolInstructionTypes.noteBlock]: NoteInstructionBlock as any,
  [EditorToolInstructionTypes.nameScript]: NameScriptInstruction as any,
  [EditorToolInstructionTypes.nameScriptBlock]: NameScriptInstructionBlock as any,
  [EditorToolInstructionTypes.document]: DocumentInstruction as any,
  [EditorToolInstructionTypes.documentBlock]: DocumentInstructionBlock as any,
  // [EditorToolInstructionTypes.webPage]: WebPageInstruction as any,
  // [EditorToolInstructionTypes.webPageBlock]: WebPageInstructionBlock as any,
};

const tools = developmentMode ? { ...EDITOR_TOOLS, ...DevelopmentTools } : EDITOR_TOOLS;

export default tools;
